import React from 'react'
import PropTypes from 'prop-types'

import ProfileBreadcrumbs from '../Profiles/ProfileBreadcrumbs'
import SettingsNav from './SettingsNav'
import styles from './SettingsLayout.module.scss'

/**
 * Two-column shell for the account/settings area: breadcrumb, left rail, content.
 *
 * Stacks below lg and goes two-column at/above it — the same single-breakpoint
 * convention ProfileTemplate uses, so the app keeps one responsive model.
 */
export default function SettingsLayout({ title, breadcrumbs = [], children }) {
  return (
    <div className={styles.page}>
      {breadcrumbs.length > 0 && (
        <div className={styles.breadcrumbs}>
          <div className="container-fluid px-4">
            <ProfileBreadcrumbs items={breadcrumbs} />
          </div>
        </div>
      )}

      <div className="container-fluid px-4">
        <div className={styles.layout}>
          <div className={styles.rail}>
            <SettingsNav />
          </div>
          <div className={styles.content}>
            {title && <h1 className={styles.title}>{title}</h1>}
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

SettingsLayout.propTypes = {
  title: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.node, to: PropTypes.string }),
  ),
  children: PropTypes.node,
}
